import { ref } from '@vue/composition-api'
import { format, isDate } from 'date-fns'

import { DATE_FORMAT } from '@constants'

export default () => {
  const filters = ref([])

  const addFilter = (key, value, dateRange = false) => {
    if (dateRange) {
      const [dateFrom, dateTo] = value.map((date) => format(date, DATE_FORMAT))

      filters.value.push({ key, value: [dateFrom, dateTo] })
    } else {
      if (isDate(value)) {
        filters.value.push({ key, value: format(value, DATE_FORMAT) })
      } else {
        filters.value.push({ key, value })
      }
    }
  }

  const removeFilter = (index) => filters.value.splice(index, 1)

  return {
    filters,
    addFilter,
    removeFilter
  }
}
